import { getConstant } from '../utils';

export const getRB = getConstant('GET_RB');
export const getRBs = getConstant('GET_RBS');
export const clearRB = getConstant('CLEAR_RB');
export const updateRB = getConstant('UPDATE_RB');
export const addRB = getConstant('ADD_RB');
